<template>
  <h6>
    {{ label }}: <span class="code text-red">{{ value }}</span>
    <span
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-primary"
      class="btn-icon rounded-circle copy-btn ml-1"
      @click.stop.prevent="copyCode(snippetId)"
    >
      <feather-icon
        size="18"
        :icon="'CopyIcon'"
      />
    </span>
    <input
      :id="snippetId"
      type="hidden"
      :value="value"
    >
  </h6>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    snippetId: {
      type: String,
      required: true,
    },
  },
  methods: {
    copyCode(id) {
      let codeToCopy = ''
      if (id === 'copy-bc-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      if (id === 'copy-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },
}
</script>

  <style lang="scss">
  </style>
